/**
 * PLP Filter Drawer — mobile slide-in panel with filters.
 */
(function () {
  const { html, useEffect, useRef } = window.preact;

  function CloseIcon() {
    return html`
      <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4l10 10M14 4L4 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    `;
  }

  function FilterDrawer({ isOpen, onClose, facets, filters, onToggleFilter, onPriceChange, totalResults }) {
    const drawerRef = useRef(null);
    const { renderFacetGroup } = window.PlpFilterComponents;

    useEffect(() => {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
      return () => {
        document.body.style.overflow = '';
      };
    }, [isOpen]);

    useEffect(() => {
      function handleEsc(e) {
        if (e.key === 'Escape' && isOpen) onClose();
      }
      document.addEventListener('keydown', handleEsc);
      return () => document.removeEventListener('keydown', handleEsc);
    }, [isOpen, onClose]);

    if (!facets) return null;
    var groups = Array.isArray(facets) ? facets : [];

    return html`
      <div
        class="plp-drawer-overlay${isOpen ? ' plp-drawer-overlay--open' : ''}"
        onClick=${onClose}
      ></div>
      <div
        class="plp-drawer${isOpen ? ' plp-drawer--open' : ''}"
        ref=${drawerRef}
        role="dialog"
        aria-modal="true"
        aria-label="Filters"
      >
        <div class="plp-drawer__header">
          <h2 class="plp-drawer__title">Filters</h2>
          <button class="plp-drawer__close" onClick=${onClose} aria-label="Close filters">
            <${CloseIcon} />
          </button>
        </div>
        <div class="plp-drawer__body">
          <div class="plp-filters">
            ${groups.map((g) => renderFacetGroup(g, filters, onToggleFilter, onPriceChange))}
          </div>
        </div>
      </div>
    `;
  }

  window.PlpFilterDrawer = FilterDrawer;
})();
